import Modifier from 'ember-modifier';
import { inject as service } from '@ember/service';
import { isDestroying } from '@ember/destroyable';
import ENV from 'sh-www/config/environment';

/**
 * Modifier to implement a google one-tap login button
 */
class GoogleSSOModifier extends Modifier {
  @service('commands.general-commands') generalCommands;
  @service('google-gis') googleGIS;

  #initialized = false;

  constructor(props) {
    super(props);
  }

  modify(
    element,
    _,
    {
      callback,
      context = 'signin',
      shape = 'rectangular',
    }
  ) {
    if (this.#initialized) {
      return;
    }

    this.#initialized = true;

    (async () => {
      // Load the Google library and get a nonce
      const [, nonce] = await Promise.all([
        this.googleGIS.load(),
        this.generalCommands.getNonce(),
      ]);

      if (isDestroying(this)) {
        return;
      }

      google.accounts.id.initialize({
        client_id: ENV.GOOGLE_CLIENT_ID,
        callback: callback,
        context: context,
        nonce: nonce.uuid,
      });

      google.accounts.id.renderButton(
        element,
        {
          type: "standard",
          shape,
          theme: "outline",
          size: "large",
          text: "signin_with",
          logo_alignment: "left",
        }, // customization attributes
      );
      google.accounts.id.prompt(); // also display the One Tap dialog
    })();
  }
}

export default GoogleSSOModifier;
